import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { AuthorizeComponent } from './authorize/authorize.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { OrganizationUserComponent } from './organization-user/organization-user.component';
import { OrganizationUsersComponent } from './organization-users/organization-users.component';

const routes: Routes = [
  // TODO path '' should redirect to home page. not login
  {path: '', component: LoginComponent, canActivate: [AuthGuardService] },
  { path: 'login', component: LoginComponent },
  // { path: 'profile', component: ProfileComponent, canActivate: [AuthGuardService]},
  { path: 'authorize', component: AuthorizeComponent, canActivate: [AuthGuardService]},
  { path: 'logout', component: LogoutComponent},
  { path: 'organizationusers', component: OrganizationUsersComponent, canActivate: [AuthGuardService]},
  { path: 'organizationuser', component: OrganizationUserComponent, canActivate: [AuthGuardService]},
  // { path: 'clients', component: ClientsComponent, canActivate: [AuthGuardService]},
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
